import React from "react";
import { ShieldCheck, BadgeCheck, Landmark } from "lucide-react";
import { trustItems } from "../mock";

const icons = { ShieldCheck, BadgeCheck, Landmark };

export default function TrustBanner() {
  return (
    <section data-testid="trust-banner" className="bg-secondary/60 border-y border-border">
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-10 grid md:grid-cols-3 gap-6 md:gap-10">
        {trustItems.map((t) => {
          const Icon = icons[t.icon];
          return (
            <div key={t.id} data-testid={`trust-item-${t.id}`} className="flex items-center gap-4">
              <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full border border-accent/40 bg-card text-accent">
                {t.id === "fnaim" ? (
                  <span className="font-serif font-bold text-[11px] tracking-wide">FNAIM</span>
                ) : (
                  <Icon className="h-6 w-6" strokeWidth={1.6} />
                )}
              </span>
              <div>
                <p className="font-serif text-lg font-semibold text-foreground leading-tight">{t.title}</p>
                <p className="text-xs text-muted-foreground mt-1 leading-relaxed">{t.text}</p>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
